<template>
  <app-popup-page>
    <div class="py-4">
      <h1 class="text-center">
        <span class="text-outline text-title-md" v-text="`${page.titolo1} `" />
        <span class="text-title-md" v-text="`${page.titolo2}`" />
      </h1>
      <section class="flex">
        <div class="prose">
          <ul>
            <li v-for="line in page.list" :key="line.title">
              <p>
                <span class="text-primary font-bold" v-text="line.title" />
                <span v-html="line.number" />
                <br />
                <span v-text="line.foreignNumber" />
              </p>
            </li>
          </ul>
        </div>
        <div class="lg:block flex-1 hidden object-contain px-10">
          <img :src="page.pageImage" />
        </div>
      </section>
    </div>
  </app-popup-page>
</template>

<script>
import { axios } from "@/plugins/axios";
export default {
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>

<route>
{
  "name": "Numeri utili",
    "meta": {
  }
}
</route>
